import {
  ADDITION,
  BIBORNE,
  FOR_MENU,
  INGREDIENT,
  PRODUCT,
  SPLASH,
  ZELTY,
} from 'src/constants';
import { hasExternalIntegration } from 'src/utils/externalIntegration';
import store from 'src/utils/store';

const allOptionsAssociatedWithProduct = (optionList: any): boolean => {
  const items = Object.values(optionList?.items || {}) as any[];
  return items.length > 0 && items.every((item) => Boolean(item?.productKey));
};

export const isOptionListAllowedBNGM = (optionList: any): boolean => {
  const { shopId } = store.getState().user;
  const externalIntegration = hasExternalIntegration(shopId);
  switch (externalIntegration) {
    case SPLASH:
      return optionList.type !== INGREDIENT;

    case BIBORNE:
    case ADDITION:
      return optionList.type === PRODUCT;

    case ZELTY:
      return optionList.key.includes(FOR_MENU);

    default:
      return allOptionsAssociatedWithProduct(optionList);
  }
};
